// extracted by mini-css-extract-plugin
export default {"Container":"TableHeader_Container__IPmWr"};